import React from 'react';
import { WidgetRequestTypeLabels } from '@televet/shared-types/widgetRequest/WidgetRequestTypeLabels';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { useWidgetStore } from 'state/useWidgetStore';
import { Flex } from '@televet/kibble-ui/build/chakra';
import { WidgetRequestType } from 'shared/types/graphql';

const FormHeader = (): JSX.Element | null => {
  const { selectedRequest } = useWidgetStore((state) => state);

  return (
    <Flex
      className="Request__Name"
      bgColor="background.secondary"
      py={3}
      px={5}
      w="100%"
      justify="space-between"
      align="center"
    >
      <Text color="text.secondaryOnContrast" fontWeight="semibold">
        {selectedRequest &&
          (selectedRequest?.displayName || WidgetRequestTypeLabels[selectedRequest?.requestType as WidgetRequestType])}
      </Text>
    </Flex>
  );
};

export default FormHeader;
